import './Accesses.scss';
import * as React from 'react';
import { actionCreator as authActions } from '../../common/Auth0/store/actions/creators';
import { IState as IAccessState } from '../../common/store/accesses/state';
import { IActions as IAccessActions, actionCreator as accessesActions } from '../../common/store/accesses/actions/creators';
import { IApplicationState } from '../../store/ApplicationState';
import { Grid, CircularProgress, StyledComponentProps, withStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import { styles } from './styles';
import Paper from '../../ui-components/Containers/Paper';
import { WithMediaQuery, IMediaQueryProps } from '../../layout/withMediaQuery';
import { AccessList } from './List/AccessList';
import { Filters } from './Filters/Filters';
// import ReminderDialog from './List/ReminderDialog.___';

interface IProps extends IAccessActions, IAccessState, IMediaQueryProps, StyledComponentProps {
    // navigateTo: (path: string) => void;
    // match: {
    //     params: {
    //         id: string
    //     }
    // }
}
interface IState {
    fullnameOrEmail: string;
    openReminderDialog: boolean;
    // selectedReminder: reminder;
}

// const DefaultRowsPerPage = 10;

class CompContainer extends React.Component<IProps, IState>
{
    state = {
        fullnameOrEmail: "",
        openReminderDialog: false,
        // selectedReminder: emptyReminder(),
    };

    componentDidMount() {
        // const { id } = this.props.match.params;
        this.props.loadAccesses(null, null);
    }

    private search = (sub?: string, date?: Date, dateTo?: Date) => {
        // console.log("--------------------------------------");
        // console.log(sub);
        // console.log(date);
        this.props.loadAccesses(sub, date, dateTo);
    }

    render() {
        return (
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Filters
                        classes={this.props.classes}
                        searchByDate={this.search}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <Paper title='Elenco'
                        collapsed={this.props.smallScreen ? true : false} // true --> this.state.contactsCollapsed 
                        fullHeight={false}
                        contentContainerStyle={this.props.smallScreen ? { minHeight: '300px' } : { heigth: 'calc(100% - 1px)' }}>
                        <Grid container justify={"center"} >
                            {this.props.isLoadingAccesses ?
                                <Grid item xs={12} style={{ display: 'flex' }}>
                                    <CircularProgress size={80} />
                                </Grid>
                                :
                                <>
                                    <Grid item xs={12} >
                                        <AccessList
                                            classes={this.props.classes}
                                            accessList={this.props.accesses}
                                            selected={null}
                                        // doneReminder={this.doneReminder}
                                        // onReminderClick={this.handleSelection}
                                        // navigateTo={this.props.navigateTo}
                                        />
                                    </Grid>
                                </>
                            }
                        </Grid>
                    </Paper>
                </Grid>
                {/* <ReminderDialog
                    classes={this.props.classes}
                    reminder={this.state.selectedReminder}
                    canChangeContact={this.state.selectedReminder._id == undefined}
                    onCancel={this.cancelDialog}
                    onSave={this.saveReminderX}
                    open={this.state.openReminderDialog}
                /> */}
            </Grid>
        );
    }
}

const mapStateToProps = (state: IApplicationState, ownP) => ({
    ...state.accesses,
    ...state.rooms,
    ...ownP
})

const mapDispatchToProps = (dispatch: any) => ({
    ...accessesActions(dispatch),
    navigateTo: authActions(dispatch).navigateTo
})

export const Accesses = connect(mapStateToProps, mapDispatchToProps)(WithMediaQuery(withStyles(styles)(CompContainer)));